<template>
  <div>
    <div class="tabs">
      <div class="tabs__actions" style="margin-left: 1px">
        <TabButton :thisTab="UL_VALUE" :currentTab="localType" @tab-change="handleClick">Компания</TabButton>
        <TabButton :thisTab="FL_VALUE" :currentTab="localType" @tab-change="handleClick">Физическое лицо</TabButton>
      </div>
      <div v-show="localType === UL_VALUE">
        <v-form ref="ulForm" v-model="ulValid" v-on:submit.prevent>
          <label class="font font--label font--color_light">
            Найти по названию, ИНН или ОГРН/ОГРНИП
            <v-icon size="16px" color="primary" @click="modal = true">{{ "mdi-information" }}</v-icon>
          </label>
          <CompanySearch
            v-model="localCompany"
            class="mb-2"
            :rules="[rules.required('')]"
            v-on:create-company="handleCreateCompany"
          />
          <div class="note d-flex font font--note font--color_white" v-if="ogrnExist">
            <div style="margin-right: 10px">
              <v-icon color="white" size="18px">{{ "mdi-alert-rhombus-outline" }}</v-icon>
            </div>
            <div>
              Компания с таким ОГРН уже зарегистрирована в Модульбанке. Если вы сотрудник этой компании, обратитесь к
              руководителю, чтобы получить доступ.
            </div>
          </div>
        </v-form>
      </div>
      <div v-show="localType === FL_VALUE">
        <v-form ref="flForm" v-model="flValid" v-on:submit.prevent style="margin-bottom: -26px">
          <ag-text-field
            :rules="[rules.required('Введите ИНН'), rules.inn12, rules.inn]"
            outlined
            required
            label="ИНН"
            v-mask="['############']"
            v-model="localInn"
            type="text"
            dense
          ></ag-text-field>
        </v-form>
      </div>
    </div>
    <v-form v-model="otherValid">
      <h4 class="font font--h2">Выберите модель вознаграждения</h4>
      <v-radio-group :rules="[rules.required('')]" v-model="localRewardType" row required>
        <v-radio v-for="reward in rewardTypes" :key="reward.value" color="#88BD1F" :label="reward.name"
                 :value="reward.value" class="_rate" />
      </v-radio-group>
      <div class="d-flex font font--note font--color_light mb-sm-0 mb-2" v-if="localRewardType">
        <div style="margin-right: 10px">
          <v-icon size="18px">{{ "mdi-information-outline" }}</v-icon>
        </div>
        <div>
          <div v-if="localRewardType === 'Progressive'">
            Мы заплатим от {{bonus.newPartnerFrom}} р до {{bonus.newPartnerTo}} р за каждого клиента, открывшего счет в нашем банке,
              доплатим {{bonus.activationCost}} р если он станет активным, а еще более {{bonus.additionalServicesCost}} р можно заработать, подключая дополнительные опции вашим клиентам.
              При привлечении новых партнеров до {{bonus.childPartnerCost}} р за их клиентов открывших счет.{{ " " }}
            <a class="text-link" target="_blank" href="https://modulbank.ru/fs/files/tarrifs_modulpartner.pdf"
            >Ознакомиться</a
            >
            с полным описанием моделей вознаграждения.
          </div>
          <div v-if="localRewardType === 'RevShare'">
            Мы заплатим
            <span v-if="localType === UL_VALUE"
            >2000 руб. за каждого приведённого клиента + до 13% от его комиссии пока он не закроет счёт. При
              привлечении новых партнёров до 7% от комиссий их клиентов.</span
            >
            <span v-if="localType === FL_VALUE"
            >1600 руб. за каждого приведённого клиента + до 10% от его комиссии пока он не закроет счёт. При
              привлечении новых партнёров до 5,5% от комиссий их клиентов.</span
            >{{ " " }}
            <a class="text-link" target="_blank" href="https://modulbank.ru/fs/files/tarrifs_modulpartner.pdf"
            >Ознакомиться</a
            >
            с полным описанием моделей вознаграждения.
          </div>
        </div>
      </div>
      <v-checkbox :rules="[rules.required('')]" color="#88BD1F" required v-model="checkbox" style="margin-bottom: 10px">
        <template v-slot:label>
          <div class="font">
            Прошу считать данное заявление заявлением на присоединение к
            <a
              @click.stop
              class="text-link"
              href="https://modulbank.ru/fs/files/oferta_modulpartner.pdf"
              target="_blank"
            >Договору-оферте</a
            >
            о партнёрстве
          </div>
        </template>
      </v-checkbox>
    </v-form>
    <div class="d-flex">
      <v-btn @click="updateMainInfo" :disabled="!valid" x-large color="primary" style="margin-left: auto"
      >Продолжить
      </v-btn
      >
    </div>

    <v-dialog scrollable max-width="560" v-model="modal">
      <v-card light style="padding: 12px">
        <v-card-title flat>
          <v-toolbar-title>ОГРН/ОГРНИП</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="modal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p class="font font--p">
            ОГРН или ОГРНИП указан в листе записи ЕГРЮЛ или ЕГРИП. Налоговая выдаёт лист записи на руки или отправляет
            на электронную почту.
          </p>
          <p class="font font--p">
            Если листа нет под рукой, введите в поисковике юридическое название компании или ФИО индивидуального
            предпринимателя — увидите свой ОГРН или ОГРНИП в справочниках.
          </p>
          <v-img src="@/assets/img/ogrn.jpg"></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TabButton from "@/components/common/TabButton";
import CompanySearch from "@/components/common/CompanySearch";
import AgTextField from "@/components/common/AgTextField";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { mask } from "vue-the-mask";
import { validateAcc, validateInn } from "@/utils/helpers";

import { rewardTypes } from "@/utils/rewardTypes";
import { FL_VALUE, UL_VALUE, IP_VALUE } from "@/utils/opfTypes";

export default {
  props: {
    newCompany: Object | null,
  },
  components: {
    AgTextField,
    TabButton,
    CompanySearch,
  },
  directives: { mask },
  mounted() {
    this.localCompany = this.company;
    this.localType = this.type === IP_VALUE || this.type === null ? UL_VALUE : this.type; // Добавился вариант IP по отображению равнозначен UL на сервер отправляем UL, начальное ставим UL
    this.localInn = this.inn;
    this.localRewardType = this.reward_type || "RevShare";
  },
  data() {
    return {
      modal: false,
      checkbox: true,
      flValid: false,
      ulValid: false,
      otherValid: false,
      localCompany: null,
      localType: UL_VALUE,
      localInn: "",
      localRewardType: "",
      rules: {
        required: (msg) => (v) => !!v || msg,
        inn12: (v) => v.length === 12 || "ИНН должен содержать 12 цифр",
        inn: (v) => validateInn(v) || "Введите корректный ИНН",
      },
      rewardTypes: rewardTypes,
      FL_VALUE,
      UL_VALUE,
      IP_VALUE,
    };
  },
  watch: {
    localType(current) {
      if (current === FL_VALUE) {
        this.$refs.flForm.resetValidation();
      }
      if (current === UL_VALUE) {
        this.$refs.ulForm.resetValidation();
      }
    },
    // Если прилетела ошибка что компания с таким огрн зарегана
    // При изменении компании сбрасываем ошибку
    localCompany() {
      if (this.ogrnExist) {
        this.setOgrnExist(false);
      }
    },
    company(v) {
      this.localCompany = v;
    },
    type(v) {
      this.localType = v === IP_VALUE ? UL_VALUE : v; // Добавился вариант IP по отображению равнозначен UL на сервер отправляем UL
    },
    inn(v) {
      this.localInn = v;
    },
    reward_type(v) {
      this.localRewardType = v;
    },
  },
  computed: {
    ...mapState("profile", ["type", "ogrnExist", "company", "inn", "reward_type"]),
    valid() {
      return (
        ((this.flValid && this.localType === FL_VALUE) || (this.ulValid && this.localType === UL_VALUE && !this.ogrnExist)) &&
        this.otherValid
      );
    },
    bonus() {
      if (this.localType === FL_VALUE) return {
        newPartnerFrom: "2300",
        newPartnerTo: "3200",
        activationCost: "700",
        additionalServicesCost: "30 000",
        childPartnerCost: "1500"
      }
      return {
        newPartnerFrom: "3000",
        newPartnerTo: "4000",
        activationCost: "1000",
        additionalServicesCost: "30 000",
        childPartnerCost: "2000"
      }
    }
  },

  updated() {
    if (this.newCompany) {
      this.localCompany = this.newCompany;
    }
  },
  methods: {
    ...mapActions("profile", ["updateProfile"]),
    ...mapMutations("profile", ["setOgrnExist"]),
    updateMainInfo() {
      const data = { leaveStepper: true };

      // Оставляем степпер после отправки этого шага,
      // только если это новая рега (данных этого шага в стейте нет)
      if (this.type || this.reward_type || this.company || this.inn) {
        data.leaveStepper = false;
      }

      // Данные обновляются только при их отсутствии в стейтте
      if (!this.type) {
        data.type = this.localType;
      }

      if (!this.reward_type) {
        data.reward_type = this.localRewardType;
      }

      if (this.localType === UL_VALUE) {
        if (!this.company) {
          data.company_name = this.localCompany.name;
          data.inn = this.localCompany.inn;
          data.ogrn = this.localCompany.ogrn;
        }
      } else {
        if (!this.inn) {
          data.inn = this.localInn;
        }
      }

      this.updateProfile(data);
    },
    handleClick(value) {
      this.localType = value;
    },
    handleCreateCompany() {
      this.$emit("create-company");
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  margin-bottom: 40px;

  &__actions {
    display: flex;
    margin-bottom: 32px;
  }

  &__btn {
    padding: 14px 16px;
    border: 1px solid #cbcdd1;
    cursor: pointer;
  }

  &__btn--active {
    background: #f2f6ff;
    border: 2px solid #4971d0;
  }
}

@media (max-width: 600px) {
  .tabs {
    margin-bottom: 10px;

    &__actions {
      margin-bottom: 4px;
    }

    &__btn {
      padding: 2px 4px;
    }
  }
  .rate {
    margin-bottom: 10px;
  }
  ._rate:last-child {
    margin-bottom: 10px;
  }
}

.note {
  background: #e36868;
  border-radius: 3px;
  padding: 14px 20px;
}
</style>
